import { AxiosRequestConfig } from 'axios'

export interface BenefitsUsedParams {
  startDate: string
  endDate: string
  storeId?: number
  storeIds?: number[]
  page?: number
  limit?: number
}

export interface BenefitData {
  id: number
  title: string
  type: string
  isCampaign?: number
  exchanges: number
  percentage: number
}

export interface StoreBenefitsData {
  storeId?: number
  storeName?: string
  benefits: BenefitData[]
  totalBenefits: number
  // eslint-disable-next-line @typescript-eslint/member-delimiter-style
  totalItems: { id: number; title: string; type: string; count: number }[]
  currentPage: number
  totalPages: number
  hasNextPage: boolean
  hasPrevPage: boolean
}

export interface BenefitsUsedResponse {
  data: StoreBenefitsData | StoreBenefitsData[]
}

const getBenefitsUsed = (params: BenefitsUsedParams): AxiosRequestConfig => ({
  url: '/dashboard/benefits-used',
  method: 'GET',
  params,
})

export { getBenefitsUsed }
